var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3430_67)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2558 2.7907V13.2093C15.2558 14.7505 14.0063 16 12.4651 16H3.53484C1.99361 16 0.744141 14.7505 0.744141 13.2093V2.7907C0.744141 1.24947 1.99361 0 3.53484 0H12.4651C14.0063 0 15.2558 1.24947 15.2558 2.7907ZM11.7209 5.95349H4.27902C3.97093 5.95349 3.72088 6.20353 3.72088 6.51163C3.72088 6.81972 3.97093 7.06977 4.27902 7.06977H11.7209C12.029 7.06977 12.279 6.81972 12.279 6.51163C12.279 6.20353 12.029 5.95349 11.7209 5.95349ZM11.7209 8.93023H4.27902C3.97093 8.93023 3.72088 9.18028 3.72088 9.48837C3.72088 9.79646 3.97093 10.0465 4.27902 10.0465H11.7209C12.029 10.0465 12.279 9.79646 12.279 9.48837C12.279 9.18028 12.029 8.93023 11.7209 8.93023ZM7.99995 2.97674H4.27902C3.97093 2.97674 3.72088 3.22679 3.72088 3.53488C3.72088 3.84298 3.97093 4.09302 4.27902 4.09302H7.99995C8.30805 4.09302 8.55809 3.84298 8.55809 3.53488C8.55809 3.22679 8.30805 2.97674 7.99995 2.97674ZM11.7209 11.907H4.27902C3.97093 11.907 3.72088 12.157 3.72088 12.4651C3.72088 12.7732 3.97093 13.0233 4.27902 13.0233H11.7209C12.029 13.0233 12.279 12.7732 12.279 12.4651C12.279 12.157 12.029 11.907 11.7209 11.907Z",
    fill: "#258E61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3430_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosts);
export default __webpack_public_path__ + "static/media/posts.47ea2a899b33ac24399c2755f1ad2476.svg";
export { ForwardRef as ReactComponent };